module.exports = __webpack_public_path__ + "static/img/yellowqita.89f3555.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/yellowqita.png
// module id = tKdh
// module chunks = 1